import { createAsyncThunk } from '@reduxjs/toolkit'

import { IWalletEvent, IWalletEventMetadata } from 'meta/pages/v4/wallet'
import { WalletController } from 'controller/wallet'
import { RootState } from 'store/types'

type Params = { page: number }

type Returned = { events: Array<IWalletEvent>; metadata: IWalletEventMetadata }

export const getUpcomingEvents = createAsyncThunk<Returned, Params, { state: RootState }>(
  'wallet/events',
  async (params) => {
    const { page } = params

    const { items, metadata } = await WalletController.getUpcomingEvents({ page })

    return { events: items, metadata }
  }
)
